import { useParams } from 'react-router-dom'
import { CurriculumList } from '@/components/curriculum-builder/CurriculumList'
import { CurriculumEditor } from '@/components/curriculum-builder/CurriculumEditor'

export function CurriculumBuilderPage() {
  const { curriculumId } = useParams<{ curriculumId: string }>()

  if (curriculumId) {
    return <CurriculumEditor curriculumId={Number(curriculumId)} />
  }

  return <CurriculumList />
}
